import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { IconButton, TableCell, TableHead, TableRow, Tooltip, useTheme, } from '@mui/material';
import { AddCircleRounded } from '@mui/icons-material';
import { GridHeaderCell } from './grid-header-cell';
import { generateColumns, generateColumnsWithDeleteButton } from './utils';
export function TableHeader(props) {
    const { columns_name, withRemoveButton, withAddButton, addButtonTooltip, addButtonClick, addButtonComponent, } = props;
    const theme = useTheme();
    const text_color = theme.palette.text.primary;
    function onClickAddButton(e) {
        e.stopPropagation();
        e.preventDefault();
        addButtonClick?.();
    }
    return (_jsx(TableHead, { children: _jsxs(TableRow, { children: [withRemoveButton
                    ? generateColumnsWithDeleteButton(columns_name)
                        .filter((col) => col.visible)
                        .map((column) => (_jsx(GridHeaderCell, { column: column, text_color: text_color }, column.name)))
                    : generateColumns(columns_name)
                        .filter((col) => col.visible)
                        .map((column) => (_jsx(GridHeaderCell, { column: column, text_color: text_color }, column.name))), withAddButton || addButtonComponent != null ? (_jsx(TableCell, { variant: "head", align: "right", children: addButtonComponent != null ? (addButtonComponent) : (_jsx(Tooltip, { title: addButtonTooltip != null
                            ? addButtonTooltip
                            : 'Добавить строку', children: _jsx(IconButton, { onClick: onClickAddButton, size: "large", children: _jsx(AddCircleRounded, {}) }) })) }, "add-button")) : null] }) }));
}
